// ======================================================================
// File Name       : ScoringReportListSearchTop
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import { VALIDATE_TYPE } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import DateTimeMinMax from '../../DateTimeMinMax';
import CustomButton from '../../button/CustomButton';

class ReportListSearchTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      reportName,
      userSubmitter,
      groupSubmitter,
      noSetCheckerFlg,
      submitted,
      checking,
      remand,
      pendingApproval,
      approved,
      resultReturned,
      checkerName,
      includeDeadlineReportFlg,
      selectedTargetGroup,
      reportId,
      displayDate,
      submissionDateFrom,
      submissionDateTo,
      updatedDateFrom,
      updatedDateTo,
    } = this.props.searchInfo;
    this.refsToValidate = [];
    const scoringManagementAuthority = this.props.scoringManagementAuthority;
    const { onShowGroupDialog, mode, onSearchReport, formValues, onChangeCheckboxTop, onRadioButtonChange } = this.props;
    let isDiableStatusOfCheckerUser = false;
    if (scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE) {
      isDiableStatusOfCheckerUser = true;
    }
    const isDiableChecker = formValues.noSetCheckerFlg;
    let groupName = null;
    if (this.props.groupList && selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      const groupSecernId = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, this.props.groupList);
    }
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchReport();
          }}
          className='form-horizontal'
        >
          <Col sm={12}>
            {/* #5854 START */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
              添削管理ID
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField
                  type="text"
                  name="reportId"
                  label="添削管理ID"
                  maxLength="256"
                  value={reportId}
                />
              </Col>
            </Form.Group>
            {/* #5854 END */}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                レポート名
              </Col>
              <Col sm={8} className="padding-right-15">
                <RenderField
                  type="text"
                  name="reportName"
                  label="レポート名"
                  maxLength="256"
                  value={reportName}
                />
              </Col>
            </Form.Group>
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  ユーザー名(提出者)
                </Col>
                <Col sm={8} className="padding-right-15">
                  <RenderField
                    type="text"
                    name="userSubmitter"
                    maxLength="40"
                    value={userSubmitter}
                  />
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  所属グループ(提出者)
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96" onClick={onShowGroupDialog}>
                    グループ選択
                  </Button>
                </Col>
              </Form.Group>
            )}
            {groupSubmitter && (
              <Form.Group className="form-info" controlId="formHorizontalGroup">
                <Col sm={4}>
                </Col>
                <Col sm={6} as={Form.Label} className="padding-left-clear">
                  {groupName}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96 margin-left-15" onClick={this.props.removeSelectedGroup}>
                    削除
                  </Button>
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  添削者名
                </Col>
                <Col sm={8} className="padding-right-15">
                  <RenderField
                    type="text"
                    name="checkerName"
                    maxLength="40"
                    value={checkerName}
                    disabled={isDiableChecker}
                  />
                </Col>
              </Form.Group>
            )}
            {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  添削者未割当てのレポートを含む
                </Col>
                <Col sm={8} className="padding-top-10">
                  <RenderField
                    className="padding-top-clear"
                    name="noSetCheckerFlg"
                    value={noSetCheckerFlg}
                    type="checkbox"
                    checked={noSetCheckerFlg}
                    checkRadioChange
                    radioChange={onChangeCheckboxTop}
                  />
                </Col>
              </Form.Group>
            )}
            <Form.Group className="form-info label-middle">
              <Col as={Form.Label} sm={4}>
                レポートステータス
              </Col>
              <Col sm={8}>
                <Col sm={4} className="padding-clear">
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="submitted"
                      value={submitted}
                      type="checkbox"
                      label="提出済み"
                    />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="pendingApproval"
                      value={pendingApproval}
                      type="checkbox"
                      label="承認待ち"
                    />
                  </Col>
                </Col>
                <Col sm={4} className="padding-clear">
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="checking"
                      value={checking}
                      type="checkbox"
                      label="添削中"
                    />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="approved"
                      value={approved}
                      type="checkbox"
                      label="承認済み"
                    />
                  </Col>
                </Col>
                <Col sm={4} className="padding-clear">
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="remand"
                      value={remand}
                      type="checkbox"
                      label="差し戻し"
                    />
                  </Col>
                  <Col sm={12} className="padding-clear">
                    <RenderField
                      name="resultReturned"
                      value={resultReturned}
                      type="checkbox"
                      label="結果返却済み"
                    />
                  </Col>
                </Col>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                提出期限切れレポートを含む
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  className="padding-top-clear"
                  type="checkbox"
                  name="includeDeadlineReportFlg"
                  value={includeDeadlineReportFlg}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                <RenderField
                  inline
                  type="radio"
                  className="padding-top-clear"
                  name="displayDate"
                  label="レポート提出日"
                  radioChange={onRadioButtonChange}
                  checkRadioChange
                  value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  normalizeRadio
                />
              </Col>
              <Col sm={3}>
                <RenderField
                  name="submissionDateFrom"
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  name="submissionDateTo"
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <DateTimeMinMax
                  shouldValidateRange
                  dateFrom={submissionDateFrom}
                  dateTo={submissionDateTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                <RenderField
                  inline
                  type="radio"
                  label="レポート更新日"
                  className="padding-top-clear"
                  radioChange={onRadioButtonChange}
                  checkRadioChange
                  name="displayDate"
                  value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  normalizeRadio
                />
              </Col>
              <Col sm={3}>
                <RenderField
                  name="updatedDateFrom"
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  name="updatedDateTo"
                  disabled={displayDate != MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                  type="datetime"
                  shouldDisabledCurrentAndAfter
                  isShowDateInput={false}
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={12}>
                <DateTimeMinMax
                  shouldValidateRange
                  dateFrom={updatedDateFrom}
                  dateTo={updatedDateTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
          <hr />
          <Col sm={12} className="text-center margin-top-10">
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              type="submit"
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form>
      </div>
    );
  }
}

export default ReportListSearchTop;
